/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator'
// import {  } from '@/utils/api/customer'
import { menuBtn } from '@/utils/menu_level2_button'


import { formatDate } from '@/utils/timeFilter'
import {getMessageRemindById} from "@/api/message";
import commonData from "@/utils/commonData";


@Component({})
export default class BClassifyCustomerInfo extends Vue {
    loading = false
    addDialog = false  //添加学校
    schoolName = ''
    schoolTypesList = [
        { value: '0', name: '海外大学' },
        { value: '1', name: '国内大学' },
        { value: '2', name: '中学' }
    ]
    schoolType = ''
    repeatName: any =null

    pageType: any = 1
    showInput: any = true
    submitButtonDisabled = false
    cancelTabkBackClueDialog: any = false
    cancelTabkBackRepeatDialog: any = false
    saveType: any = 1
    repeatDialog: any = false
    repeatDetailList: any = []
    repeatStudentName: any = false
    repeatStudentIphone: any = false
    repeatStudentWeixin: any = false
    repeatStudentNameList: any = []
    repeatStudentIphoneList: any = []
    repeatStudentWeixinList: any = []
    customerBusinessDataList: any =[] //相关资料
    formData: any = {
        name: null,
        sourceType: null,
        marketChannelId: null,
        source: null,
        realName: null,
        gender: null,
        phone: null,
        email: null,
        weChat: null,
        attendSchool: null,
        schoolId: null, //学校id
        grade: null,
        specialized: null,
        remark: null,
        parentName: null,
        parentPhone: null,
        parentWeChat: null,
        targetSchool: null,
        achievement: null,
        feedback: null,
        createdAt: new Date(),
        createdUserRealName: null,
        customerBusinessDataList: [],
        directorUserId: null,
        customerBusinessShareUserIdList: [],
        isDraft: '0',
        ipqSubject: '', // ipq学科方向
        courseTypeId: '',// 意向项目类型
        intentionality: '', // 意向程度
        adviser: '', // 送生顾问
        eduTemand: '', // 升学需求
    }
    sourceList: any = [
        { name: '合作伙伴', val: '0' },
        { name: '市场渠道', val: '1' },
        { name: '其它', val: '2' },
        // { name: '高校', val: '3' },
        // { name: '分管', val: '4' },
    ]
    schoolArr: any = []
    schoolList: any = []
    sourceChildList: any[] = []
    cooperativePartnerList: { name: string; id: number }[] = [] // 合作伙伴列表

    rules: {

    }

    operationShow = true
    draftId: null
    page = null
    scrollHeight: any = null
    scrollTop: any = null
    clientHeight: any =null
    name: any =null
    marketLevelPage = 1
    marketLevelSize = 20
    // marketLevelTotal = 0
    cooperativePartnerName = ''
    marketLevelloading = false
    eduTemandOptions = [ '留学', '高考', '考研', '保研', '考博', '无升学需求' ];
    typeList= commonData.projectTypeArray
    tableData=[] // 跟进记录表
    eduTemand = []

    followTotal = 0
    followLimit = 20
    followPage = 1
    types = ''
    logData = []
    total = 0


    get elImageUrls() {
        return this.formData ? this.formData.customerBusinessDataList.map(item => item.url) : []
    }

    formatDate = formatDate
    menuBtn = menuBtn

    created() {

        const url = window.location.href
        const p = url.split('?')[1]
        const params = new URLSearchParams(p)
        const recordId = params.get('id')
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.getMsgData(recordId)
    }



    async getMsgData(id) {
        const data: any = await getMessageRemindById({id: id})
        this.formData = data.result.messageRemindInfo
        this.logData = data.result.messageRemindInfo.customerBusinessLogList
        this.tableData = data.result.messageRemindInfo.customerBusinessFollowList
        this.total = this.tableData.length
    }


}
